// Simply Pencils — Shared Pun Library
// Used by the Pun-derground and homepage.
// Edit jokes here to update both locations.

window.SimplyPencilsJokes = [
  // SHARP THINKING
  "I tried telling a pencil joke, but nobody got the point.",
  "Graphite minds think alike!",
  "A pencil without a point is completely pointless.",
  "2B or not 2B, that is the question.",
  "I used to be dull, but I've sharpened up.",
  {
    q: "Why did the pencil get promoted?", a: "It knew how to draw attention.",
  },
  "My pencil broke. That's where things started going wrong.",
  "I asked my pencil for advice. It told me to draw my own conclusions.",
  {
    q: "Why was the pencil so confident?", a: "It was always on point.",
  },
  "My pencil has a great personality. It's a real character.",
  {
    q: "Why did the pencil go to school?", a: "To sharpen its skills.",
  },
  "I told my pencil to relax. It was under too much pressure.",
  {
    q: "What did the pencil say to the paper?", a: "I find you very drawing!",
  },
  "This idea wrote itself.",
  "Sketching out my life plan.",
  "Drawn to good vibes.",
  "Notes so sharp they cut.",
  "Born to doodle.",
  "My thoughts need erasing sometimes.",
  "The pencil went to therapy. It had too many unresolved issues.",
  {
    q: "What did one pencil say to the other?", a: "You're looking sharp!",
  },
  {
    q: "Why are pencils good friends?", a: "They're always write there.",
  },
  "I made a mistake, but I'm trying to erase the evidence.",
  "The pencil won the argument. It made a very good point.",
  "I dated a pencil once. There was no chemistry, but we had a good draw.",
  {
    q: "Why did the pencil quit its job?", a: "It felt completely drawn out.",
  },
  "Pencils make great leaders. They always know how to make their mark.",
  "Why did the pencil blush? Someone called it a fine point.",

  // LEADERSHIP AND GRAPHITE
  "Follow my lead. Actually, it's graphite.",
  "I was born to lead. My pencil disagrees.",
  "My pencil has leadership potential. It's a natural No. 2.",
  "I don't mean to graphite all over your plans.",
  "The pencil became a manager. It had a sharp eye for detail.",
  "Lead by example. Write by pencil.",
  "I asked for a raise. My pencil drew a blank.",
  "Our pencil committee has reached a fine point.",
  {
    q: "Why did the pencil run for office?", a: "It wanted to make a mark.",
  },
  "The pencil's presentation was outstanding. Very well drawn.",
  "Never underestimate a pencil with a point to prove.",
  "My pencil has a bright future. It's still got plenty of lead.",
  "The pencil's career took off after it made a few connections.",
  "I tried to argue with a pencil. It kept making valid points.",
  "The pencil became famous for its outstanding line of work.",
  "The pencil didn't need a title. It already had a point.",
  {
    q: "Why did the pencil start it's own business?", a: "To draw in customers.",
  },
  "The pencil got the job. Its references were outstanding.",
  "My pencil's work ethic is impressive. It never draws the line.",
  "The pencil started a podcast. It had some sharp observations.",

  // ERASERS AND MISTAKES
  "I make mistakes. That's why my pencil has an eraser.",
  "My eraser has a clean record.",
  {
    q: "Why did the eraser get promoted?", a: "It cleared up every problem.",
  },
  "I asked my eraser about yesterday. It said, What yesterday?",
  "My pencil and eraser have a complicated relationship.",
  "The eraser opened a cleaning service. Business disappeared.",
  "I'm not wrong. I'm just temporarily erasable.",
  {
    q: "Why did the eraser become a detective?", a: "It was good at removing evidence.",
  },
  "My eraser is an optimist. Every mistake is a fresh start.",
  "The pencil apologized. The eraser wiped the slate clean.",
  "I tried to erase my problems. Now I need a new eraser.",
  "The eraser has one job, and it's rubbing me the wrong way.",
  {
    q: "Why did the pencil trust the eraser?", a: "It always had its back.",
  },
  "My eraser retired early. It was worn down by the job.",
  "I never make mistakes. My eraser tells a different story.",
  "The eraser went on vacation. It needed to clear its head.",
  {
    q: "Why did the pencil avoid drama?", a: "It preferred clean endings.",
  },
  "Lead the way...",
  "My eraser is a magician. Watch that mistake disappear!",
  "I made a typo in pencil. It was a temporary setback.",
  {
    q: "Why did the pencil break up with the eraser?", a: "Because it couldn't handle being rubbed the wrong way.",
  },
  "The eraser said goodbye. It wanted a clean break.",

  // SCHOOL AND CLASSROOM
  {
    q: "Why did the pencil ace the test?", a: "It had all the write answers.",
  },
  "My pencil loves math. It can always draw a conclusion.",
  {
    q: "Why did the pencil sit in the front row?", a: "To stay sharp.",
  },
  "The pencil got detention. It crossed the line.",
  "My pencil is a straight-A student. Mostly because of its ruler.",
  {
    q: "Why did the pencil late?", a: "It got caught in a sketchy situation.",
  },
  "The pencil joined art class. It was drawn to the subject.",
  "My pencil's favorite subject is history. It loves a good outline.",
  "Why did the pencil study geometry? It wanted to understand every angle.",
  "The pencil forgot its homework. It drew a blank.",
  "My pencil loves spelling. It knows all the write words.",
  {
    q: "Why did the pencil get an award?", a: "Outstanding penmanship.",
  },
  "The pencil tried public speaking. It made a few good points.",
  "My pencil failed gym class. It couldn't draw a breath.",
  {
    q: "Why did the pencil bring a ruler?", a: "To keep things in line.",
  },
  "The pencil passed its final exam. It was a sharp student.",
  "My pencil has a degree in fine arts. Naturally.",
  {
    q: "Why did the pencil love recess?", a: "It needed a break from the pressure.",
  },
  "The pencil joined the debate team. It always had a point.",
  "My pencil's report card was excellent. No marks against it.",

  // LOVE AND FRIENDSHIP
  "I'm drawn to you.",
  "You're just write for me.",
  "You make my heart skip a line.",
  "You're the point of my day.",
  "Our friendship is written in graphite.",
  "I think we make a sharp pair.",
  "You're my favorite person to pencil in.",
  "Love you to the end of the lead.",
  "You make every day a little less dull.",
  "I'm not sketching. You're amazing.",
  "Our love story is still being written.",
  "You had me at hello. I wrote it down.",
  "You're the highlight of my notebook.",
  "I never want to erase you from my life.",
  "You're the write kind of wonderful.",
  "My heart drew a picture of you.",
  "We're a match made in stationery.",
  "You give my life a little more definition.",
  "I can't draw a future without you.",
  "Together, we're always on point.",

  // COMPLETELY POINTLESS
  "I'm not a pencil pusher, I'm a pencil enthusiast!",
  "When it comes to drawing conclusions, I'm really sharp!",
  "I used to be a pencil, but now I'm a pen - I really made my mark!",
  "My pencil won the race; it was simply a-graph-tastic!",
  "I'm just trying to make a point with my pencil!",
  "My pencil broke up with me. It said I was too dull!",
  "I'm drawing a blank, but I'll pencil in some ideas shortly!",
  "Why did the pencil cross the road? To draw attention.",
  {
    q: "What do you call a pencil with no point?", a: "Pointless.",
  },
  "My pencil told a joke. It was a little sketchy.",
  {
    q: "Why don't pencils gossip?", a: "They don't want to spread graphite.",
  },
  "I tried to sharpen my pencil with a spoon. It was pointless.",
  "The pencil opened a restaurant. Its specialty was fine lines.",
  "Why did the pencil visit the doctor? It wasn't feeling sharp.",
  "My pencil joined a band. It played lead guitar.",
  {
    q: "Why did the pencil go fishing?", a: "To draw out the big ones.",
  },
  "The pencil became a comedian. Its jokes were well drawn.",
  "I told my pencil a secret. It wrote everything down.",
  {
    q: "Why did the pencil go camping?", a: "It wanted to rough-sketch it.",
  },
  "My pencil is a terrible driver. It keeps crossing lines.",
  "The pencil went to a party. It really made its mark.",
  {
    q: "Why did the pencil love the beach?", a: "It could draw in the sand.",
  },
  "My pencil tried gardening. It planted a few ideas.",
  {
    q: "Why did the pencil get lost?", a: "It couldn't draw a map.",
  },
  "The pencil became a chef. It specialized in sketchy recipes.",
  "My pencil loves mysteries. It always follows the plot.",
  "The pencil went to bed early. It was completely drawn out."
];
